import { DateTime } from "luxon";
import type { FC } from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { useIsMobile } from "../../hooks/useMobile";
import { RequestsPanel } from "./RequestPanel";

interface RequestRouteWrapperProps {
	getDepartmentId: () => string | null;
}

export const RequestRouteWrapper: FC<RequestRouteWrapperProps> = ({ getDepartmentId }) => {
	const { isMobile } = useIsMobile();
	const { id: requestId } = useParams();
	const [searchParams] = useSearchParams();
	const departmentId = getDepartmentId();

	if (!isMobile) {
		const dateParam = searchParams.get("date");
		const date = dateParam || DateTime.now().toFormat("yyyy-MM-dd");
		const redirectPath = `/${departmentId}/staffing/${date}?requestId=${requestId}`;
		return <Navigate to={redirectPath} replace />;
	}

	return <RequestsPanel />;
};
